<template>
  <v-card class="mx-auto chartCard elevation-0" color="white" max-width="300">
    <div class="percentsStatus">
      <p>
        <span
          v-if="percentageConvert(series, 0)"
          class="mr-3 body-2 font-weight-thin"
          style="color: #4caf50"
          >{{ percentageConvert(series, 0) }}</span
        >
        <span
          v-if="percentageConvert(series, 1)"
          class="mr-3 body-2 font-weight-thin"
          style="color: #ffab00"
          >{{ percentageConvert(series, 1) }}</span
        >
      </p>
      <p>
        <span
          class="mr-3 body-2 font-weight-thin"
          style="color: #c62828"
          v-if="percentageConvert(series, 2)"
          >{{ percentageConvert(series, 2) }}</span
        >
        <span
          class="mr-3 body-2 font-weight-thin"
          style="color: #696a6d"
          v-if="percentageConvert(series, 3)"
          >{{ percentageConvert(series, 3) }}</span
        >
      </p>
    </div>
    <div class="pr-1">
      <apexchart
        type="donut"
        :options="chartOptions"
        :series="series"
      ></apexchart>
    </div>
    <h6
      class="text-xs-center px-3 blue-grey--text text--darken-3 caption font-weight-bold"
    >
      {{ docName.toUpperCase() }}
    </h6>
    <v-layout row wrap>
      <v-flex xs12 row pt-3 layout pb-2 align-center justify-center>
        <div class="statusRounded ml-2 mr-1" style="background: #4caf50"></div>
        <span class="mr-1 subheading" style="color: #4caf50">{{
          series[0]
        }}</span>
        <div class="statusRounded ml-2 mr-1" style="background: #ffab00"></div>
        <span class="mr-1 subheading" style="color: #ffab00">{{
          series[1]
        }}</span>
        <div class="statusRounded ml-2 mr-1" style="background: #c62828"></div>
        <span class="mr-1 subheading" style="color: #c62828">{{
          series[2]
        }}</span>
        <div class="statusRounded ml-2 mr-1" style="background: #696a6d"></div>
        <span class="mr-1 subheading" style="color: #696a6d">{{
          series[3]
        }}</span>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
export default {
  name: 'DocumentsChartsDashboard',

  props: {
    docName: String,
    series: Array
  },

  data () {
    return {
      chartOptions: {
        stroke: {
          show: false
        },
        colors: ['#4caf50', '#ffab00', '#c62828', '#696a6d', '#4caf50'],
        chart: {
          fontFamily: 'Avenir, Helvetica, Arial, sans-serif',
          width: 100,
          type: 'donut',
          dropShadow: {
            enabled: false,
            top: 0,
            left: 0,
            blur: 4,
            opacity: 0.2
          }
        },
        plotOptions: {
          pie: {
            startAngle: 0,
            donut: {
              size: '65%'
            }
          }
        },
        labels: ['Vigentes', 'A vencer', 'Vencidos', 'Em obtenção'],
        dataLabels: {
          enabled: false,
          offsetY: -50000,
          style: {
            colors: ['#000000', '#000000', '#000000', '#000000', '#000000']
          }
        },
        fill: {
          colors: ['#4caf50', '#ffab00', '#c62828', '#696a6d', '#4caf50']
        },
        legend: {
          show: false,
          dropShadow: {
            enabled: false,
            top: 0,
            left: 0,
            blur: 4,
            opacity: 1
          }
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 100
              },
              legend: {
                show: false
              }
            }
          }
        ]
      }
    }
  },

  methods: {
    percentageConvert (all, ind) {
      let array = this.roundPercentageTotals(JSON.parse(JSON.stringify(all)))
      let value = array[ind]

      return value > 0 ? `${array[ind]}%` : ''

    },
    roundPercentageTotals(numArr, count = 0) {
        function compareNumbers(a, b) {
            return b - a;
        }
        
        var total = numArr[0] + numArr[1] + numArr[2] + numArr[3];
        var num1Percent = Math.round((numArr[0] / total) * 100)
        var num2Percent = Math.round((numArr[1] / total) * 100)
        var num3Percent = Math.round((numArr[2] / total) * 100)
        var num4Percent = Math.round((numArr[3] / total) * 100)

        var totalPercentage = num1Percent + num2Percent + num3Percent + num4Percent;

        if (totalPercentage != 100) {
          let index = numArr.indexOf(numArr.sort(compareNumbers)[0]);

          numArr[index] = numArr[index] - (totalPercentage - 100);

          if (count < 5) {
            return this.roundPercentageTotals(numArr, count + 1); 
          } else {
            let diff = 100 - totalPercentage;

            if (index == 0) {
              num1Percent += diff;
            } else if (index == 1) {
              num2Percent += diff;
            } else if (index == 2) {
              num3Percent += diff;
            } else if (index == 3) {
              num4Percent += diff;
            }
          }
        }

        return [num1Percent, num2Percent, num3Percent, num4Percent];
    }
  }
}
</script>

<style>
.percentsStatus {
  position: absolute;
  top: 50%;
  left: 10px;
  min-width: 100%;
  transform: translateY(-82%);
}

.mxHeightScroll {
  max-height: 180px !important;
  overflow-y: auto;
  padding-bottom: 5px;
}
.chartCard .v-expansion-panel__header {
  padding-left: 15px !important;
  padding-right: 15px !important;
}
.chartCard ul.v-expansion-panel {
  border-top: 1px solid #eee;
  box-shadow: none !important;
}
button.detailsDocs {
  z-index: 2 !important;
}
</style>
